import { Pagination } from '@alfresco/js-api';
import { ProcessInstanceEntry } from './process-instance-entry';

/**
 * REST API model
 */
export class ProcessInstancePagingList {
  pagination: Pagination;
  entries: ProcessInstanceEntry[];

  constructor(input?: any) {
    if (input) {
      Object.assign(this, input);
      this.pagination = input.pagination ? new Pagination(input.pagination) : undefined;
      if (input.entries) {
        this.entries = input.entries.map((item: any) => {
          return new ProcessInstanceEntry(item);
        });
      }
    }
  }
}
